// extracted by mini-css-extract-plugin
export default {"zoomControls":"Oaa-z","zoomControlButton":"Paa-z","zoomBanner":"Qaa-z","bannerButton":"Raa-z","imageButton":"Saa-z","zoom":"Taa-z","zoomContent":"Uaa-z"};